
import { defineComponent, PropType } from "vue";

interface TabData {
  text: string;
  data?: unknown;
}

export default defineComponent({
  name: "Tabs",
  props: {
    tabs: {
      type: Array as PropType<TabData[]>,
      required: true,
    },
    selectedIndex: {
      type: Number,
      required: true,
    },
  },
  emits: ["update:selectedIndex"],
});
